module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/code/option-c20acc6c577162f55cfe2f2771abec0c.svg";